<template>
    <el-dialog
        :title="projectCn + `${community ? '-' : ''}` + communityCn + '居民信息导入'"
        :visible.sync="importDialog"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="false"
        width="680px"
        center>
        <el-form ref="importForm" label-width="150px">
            <el-form-item label="第一步：选择楼门户" v-if="user.power === 3">
               <div class="flex">
                   <el-select v-model="project" placeholder="社区" @change="projectChange">
                       <el-option
                           v-for="item in projectList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                       </el-option>
                   </el-select>
                   <el-select class="margin-lr-xs" v-model="community" placeholder="小区" @change="twoChange">
                       <el-option
                           v-for="item in communityList"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                       </el-option>
                   </el-select>
                   <el-select v-model="lou" placeholder="楼栋" @change="buildingChange">
                       <el-option
                           v-for="item in buildingList"
                           :key="item.id"
                           :label="item.building_name"
                           :value="item.id">
                       </el-option>
                   </el-select>
                   <el-select class="margin-left-xs" v-model="dan" placeholder="单元" @change="unitChange">
                       <el-option
                           v-for="item in unitList"
                           :key="item.id"
                           :label="item.element_name"
                           :value="item.id">
                       </el-option>
                   </el-select>
               </div>
            </el-form-item>
            <el-form-item label="第一步：选择楼/单元" v-else>
                <el-cascader
                    class="w-all"
                    v-model="unit"
                    :options="building"
                    :props="{ expandTrigger: 'hover' }"
                ></el-cascader>
            </el-form-item>
            <el-form-item label="第二步：上传文件" prop="file" v-if="unit.length>1">
                <el-upload
                    ref="upload"
                    :action="upUrl + '/Index/Importexcel/importJuMinExcel'"
                    :name="'file'"
                    :limit="limit"
                    :data="fileData"
                    :file-list="fileList"
                    :before-upload="beforeUpload"
                    :on-exceed="handleExceed"
                    :on-success="handleAvatarSuccess"
                >
                    <el-button type="primary" plain> + 点击添加文件</el-button>
                </el-upload>
            </el-form-item>
            <el-form-item class="flex align-center justify-around margin-top" label-width="0">
                <el-button class="padding-lr-xl" type="primary" @click="resetForm('importForm')">暂不导入</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>
import {getLouMenListByYuanGong} from "@/api/resident";
import {ONLINEHOST, QAHOST} from "@/config";
import {getDanYuanList, getLouHaoList, getXiangMuList, getXiaoQuList} from "@/api/common";

export default {
    name: "importDialog",
    props: {
        importDialog: {
            type: Boolean,
            default: false
        },
    },
    data() {

        return {
            upUrl: process.env.NODE_ENV === 'production' ? ONLINEHOST : QAHOST,
            project: '',
            projectCn: '',
            community: '',
            communityCn: '',
            lou: '',
            buildingList: [],
            dan: '',
            unitList: [],
            projectList: [],
            communityList: [],
            building: [],
            unit: [],
            limit: 1,
            fileList: [],
            loading: null
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },
        fileData() {
            return {
                token: this.user.token,
                xiangMuId: this.project,
                xiaoQuId: this.community,
                louId: this.unit.length > 0 ? this.unit[0] : '',
                menId: this.unit.length > 0 ? this.unit[1] : ''
            };
        },
    },
    created() {
        if (this.user.power === 6) this.getInfo()
        if (this.user.power === 3) this.getXiangMuList()
    },
    methods: {
        async getXiangMuList() {
            let _data = await getXiangMuList()
            this.projectList = _data.data
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', true)
        },
        // 上传失败
        handleExceed() {
            this.$message.error('请先删除当前已上传的文件')
        },
        //  上传成功
        handleAvatarSuccess(res) {
            console.log(res)
            if (res.status === 200) {
                this.loading.close();
                this.$confirm('数据已导入成功，是否继续导入', '温馨提示', {
                    confirmButtonText: '继续导入',
                    cancelButtonText: '暂不导入',
                }).then(() => {
                    this.$refs['upload'].clearFiles()
                    this.unit = []
                }).catch(() => {
                    this.$emit('cancelDialog', true)
                });
            } else {
                this.loading.close();
                this.$message.error(res.info)
                this.$refs['upload'].clearFiles()
            }
        },
        //  上传前
        beforeUpload() {
            this.loading = this.$loading({
                lock: true,
                text: '导入中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            });
            setTimeout(() => {
                this.loading.close();
            }, 10000);
        },
        //  获取导入的楼号和单元
        async getInfo() {
            let _data = await getLouMenListByYuanGong()
            this.project = _data.data.xiangmu_id
            this.projectCn = _data.data.xiangmu_name
            this.community = _data.data.xiaoqu_id
            this.communityCn = _data.data.xiaoqu_name
            let _arr = []
            _data.data.list.map((item, index) => {
                _arr.push({
                    value: item.id,
                    label: item.building_name,
                    children: []
                })
                item.element_list.map(items => {
                    _arr[index].children.push({
                        value: items.id,
                        label: items.element_name
                    })
                })
            })
            this.building = _arr
        },
        //  获取单元
        async getUnit() {
            let _data = await getDanYuanList(this.lou)
            this.unitList = _data.data
        },
        //  获取楼栋
        async getBuild() {
            let _data = await getLouHaoList(this.community)
            this.buildingList = _data.data
        },
        //  获取小区
        async getXiaoQuList() {
            let _data = await getXiaoQuList(this.project)
            this.communityList = _data.data
        },
        projectChange(e) {
            this.projectCn = this.projectList.find(f => {
                return f.id === e
            }).name
            this.community = ''
            this.communityCn = ''
            this.communityList = []
            this.building = []
            this.unit = []
            this.lou = ''
            this.buildingList = []
            this.dan = ''
            this.unitList = []
            this.getXiaoQuList()
        },
        twoChange(e) {
            this.communityCn = this.communityList.find(f => {
                return f.id === e
            }).name
            this.building = []
            this.unit = []
            this.lou = ''
            this.buildingList = []
            this.dan = ''
            this.unitList = []
            this.getBuild()
        },
        buildingChange(e) {
            this.building = []
            this.unit = [e]
            this.dan = ''
            this.unitList = []
            this.getUnit()
        },
        unitChange(e) {
            this.unit.push(e)
        }
    },
    watch: {
        importDialog() {
            if (this.importDialog) {
                this.unit = []
                this.$nextTick(() => {
                    this.$refs['upload'].clearFiles()
                })
            }
        }
    }
}
</script>

<style scoped lang="scss">

</style>